import {RootStore} from '../../stores/RootStore';
import {PanoramaTransactions} from '../../../../constants/app';
import {getCtaButtonClickHandler} from './getCtaButtonClickHandler';
import {WidgetEventHandler} from './types';
import {createCheckout} from '../createCheckout';

export const handleSubscribeNowClick = (rootStore: RootStore): WidgetEventHandler<any> => {
  return getCtaButtonClickHandler(rootStore, () =>
    rootStore.reportPanoramaTransaction(PanoramaTransactions.Subscribe, () =>
      createCheckout(rootStore, {withNavigateToCheckout: true}),
    ),
  );
};
